import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'app/core/core.module';
import { TollRoutingModule } from './toll-routing.module';
import { MaterialListModule } from '@components/material-list/material-list.module';
import { SiteListModule } from '@components/site-list/site-list.module';
import { TollModule as _TollModule } from './pages/toll/toll.module';

@NgModule({
  imports: [
    CommonModule,
    TollRoutingModule,
    CoreModule,
    MaterialListModule,
    SiteListModule,
    _TollModule
  ],
  declarations: [  ]
})
export class TollModule { }
